<template>
  <div class="single-view solutions">
    <view-background
      ref="background"
      :background="background"
      :animation-options="bgOptions" />

    <hero-block
      :title="title"
      :subtitle="subtitle"
      :animate-in="entering"
      :animation-direction="animationDirection" />

    <content-wrapper>
      <one-column-content>
        <header class="block--header">
          <h2>Tecnica e tecnologia della vinificazione.</h2>
        </header>

        <div class="block--content">
          <h3>Soluzioni specifiche</h3>
          <h4>Il laboratorio Pololab fornisce soluzioni specifiche ed innovative per risolvere i problemi legati alla produzione del vino.<br /></h4>

          <div v-scroll-to-me="$route.hash === '#articoli'" id="articoli" class="article-list">
            <ul>
              <li
                v-for="article of list"
                :key="article.slug">
                <router-link :to="{ name: 'article', params: { slug: article.slug } }">{{ article.title }}</router-link>
              </li>
            </ul>
          </div>

          <figure>
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/solutions/logo_pololab.jpg')">
              <img :src="require('@/assets/solutions/logo_pololab.jpg')" alt="Soluzioni area noleggio Rossetto">
            </picture>
          </figure>
        </div>
      </one-column-content>
    </content-wrapper>
    <global-footer />
  </div>
</template>

<script>
import guards from './SingleView/guards'
import garbage from './SingleView/garbage'
import backgrounds from './SingleView/backgrounds'
import HeroBlock from '../components/HeroBlock'
import ContentWrapper from '../components/ContentWrapper'
import GlobalFooter from '../components/GlobalFooter'
import OneColumnContent from '../components/ContentWrapper/OneColumnContent'
import Accordion from '../components/Accordion'
import RossettoButton from '../components/RossettoButton'
import ViewBackground from '../components/ViewBackground'
import VisualCounter from '../components/VisualCounter'
import { mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  mixins: [ guards, garbage, backgrounds ],
  components: {
    HeroBlock,
    ContentWrapper,
    GlobalFooter,
    OneColumnContent,
    Accordion,
    RossettoButton,
    ViewBackground,
    VisualCounter
  },
  data: () => ({
    title: 'Soluzioni',
    subtitle: 'Le maggiori criticità nella produzione di vino: risolte.',
    accordionData: require('../components/Accordion/soluzioni-accordion.json'),
    accordionDataProdotti: require('../components/Accordion/soluzioni-accordion-prodotti.json'),
    bgName: 'solutions',
    bgOptions: {
      wave: {
        horizontalSpread: 10,
        verticalSpread: 5
      }
    }
  }),
  computed: {
    ...mapGetters('articles', [
      'list'
    ])
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getArticles()
    })
  },
  methods: {
    ...mapActions('articles', [
      'getArticles'
    ]),
    ...mapMutations('animations', [
      'addPixiApp'
    ])
  },
  directives: {
    'scroll-to-me': {
      update (el, binding) {
        if (binding.value) {
          el.scrollIntoView({ behavior: 'smooth' })
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/breakpoint.scss';

.solutions {
  .block--header {
    h2 {
      max-width: 780px;
    }
  }

  .article-list {
    background-color: #001b53;
    font-size: 1.8rem;
    font-weight: 300;
    line-height: 24px;
    color: white;
    padding: 75px 7.5%;

    @include media(">=large") {
      padding: 150px 15%;
      font-size: 3.6rem;
      line-height: 48px;
    }

    ul {
      li {
        margin-bottom: 3rem;

        &::before {
          background-image: url("data:image/svg+xml,%3Csvg width='30px' height='19px' viewBox='0 0 30 19' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EShape%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='DESKTOP' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='06_Soluzioni' transform='translate(-248.000000, -2426.000000)' fill-rule='nonzero' fill='%23FFFFFF'%3E%3Cg id='back' transform='translate(263.000000, 2435.500000) rotate(-180.000000) translate(-263.000000, -2435.500000) translate(248.000000, 2426.000000)'%3E%3Cpath d='M9.9159292,1.45659908 C10.2477876,1.13215937 10.2477876,0.577908218 9.9159292,0.253468517 C9.59734513,-0.0844895055 9.06637168,-0.0844895055 8.73451327,0.253468517 L0.238938053,8.89167556 C-0.0796460177,9.22963358 -0.0796460177,9.77036642 0.238938053,10.1083244 L8.73451327,18.7465315 C9.06637168,19.0844895 9.59734513,19.0844895 9.9159292,18.7465315 C10.2477876,18.4220918 10.2477876,17.8678406 9.9159292,17.5434009 L2.86725664,10.3651725 L29.1637168,10.3651725 C29.6283186,10.3651725 30,9.97314123 30,9.5 C30,9.02685877 29.6283186,8.64834578 29.1637168,8.64834578 L2.86725664,8.64834578 L9.9159292,1.45659908 Z' id='Shape'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
          height: 19px;
          width: 31px;
          background-color: transparent;
          background-repeat: no-repeat;
          transform: translateY(0.4rem);

          @include media(">=large") {
            transform: translateY(0rem);
          }
        }
      }
    }

    a {
      color: white;
      text-decoration: none;
      position: relative;
      font-weight: 300;
      flex-shrink: 30;

      &:after{
        display: block;
        content: "";
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 1px;
        background: white;
        transform: scaleX(0);
        transform-origin: right;
        transition: transform .3s ease-out;
      }

      &:hover{
        &:after{
          transform: scaleX(1);
          transform-origin: left;
        }
      }
    }
  }
}
</style>
